// Microsoft Azure Entra ID Login page component
import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuthContext as useAuth } from '../contexts/AuthContext';
import { appInfo } from '../config/appInfo';
import toast from 'react-hot-toast';

export const LoginPage: React.FC = () => {
  const navigate = useNavigate();
  const { login, isAuthenticated, isLoading, error, clearError } = useAuth();

  useEffect(() => {
    if (isAuthenticated) {
      navigate('/dashboard');
    }
  }, [isAuthenticated, navigate]);

  useEffect(() => {
    if (error) {
      toast.error(error);
      clearError();
    }
  }, [error, clearError]);

  const handleMicrosoftLogin = async () => {
    try {
      await login();
    } catch (err) {
      toast.error('Login failed. Please try again.');
    }
  };

  return (
    <div className="min-h-screen bg-gray-900 flex items-center justify-center relative">
      <div className="bg-gray-800 w-full max-w-md p-8 rounded-xl shadow-2xl border border-gray-700">
        <div className="flex items-center mb-8">
          <div className="w-12 h-12 bg-blue-600 rounded-lg flex items-center justify-center text-white font-bold text-xl mr-4">
            CMA
          </div>
          <div>
            <h1 className="text-2xl font-bold text-white">NEC Checkpoint Management</h1>
            <p className="text-gray-400 text-sm">Passenger Flow & Wait Times</p>
          </div>
        </div>
        
        <div className="text-center mb-8">
          <h2 className="text-xl font-semibold text-white mb-2">Welcome to</h2>
          <p className="text-gray-400">
          HDOT Checkpoint Management System
          </p>
        </div>
        
        <div className="space-y-4">
          <button
            onClick={handleMicrosoftLogin}
            disabled={isLoading}
            className="w-full flex items-center justify-center px-4 py-3 border border-gray-600 rounded-lg text-white bg-gray-700 hover:bg-gray-600 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 focus:ring-offset-gray-800 transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
          >
            {isLoading ? (
              <>
                <div className="animate-spin rounded-full h-5 w-5 border-b-2 border-white mr-3"></div>
                Signing in...
              </>
            ) : (
              <>
                Login
              </>
            )}
          </button>
          
          {/* <div className="text-center">
            <p className="text-gray-500 text-sm">
              Secure authentication powered by Microsoft Azure
            </p>
          </div> */}
        </div>
        
        <div className="mt-8 pt-6 border-t border-gray-700">
          <div className="text-center text-sm text-gray-500">
            <p>Having trouble signing in?</p>
            <p className="mt-1">Contact your system administrator</p>
          </div>
        </div>
      </div>
      
      {/* Version Information */}
      <div className="absolute bottom-4 left-4 text-gray-500 text-xs space-y-1">
        <div className="flex items-center space-x-3">
          <span>Version: {appInfo.version}</span>
          <span>•</span>
          <span>Environment: {appInfo.environment}</span>
          <span>•</span>
          <span>Database: {appInfo.database}</span>
        </div>
        <div className="text-gray-600">
          Updated: {appInfo.lastUpdated}
        </div>
      </div>
    </div>
  );
};